module.exports = __webpack_public_path__ + "static/media/sheer-dream.9e2027b1.png";